import { Button } from "@mui/material";

import { MultiSelectWithSelectAll } from "v2/components/ui";
import { DOCUMENTOS } from "v2/pages/Workspace/Activity/documentos-obrigatorios";
import { Subtitle } from "./Rules.styled";
import { MapaPorParentesco, ROTULO_PARENTESCO, linhasDeParentesco, sugestao, uniao } from "./parentesco";

/** União do mapa na ordem da lista que já existia; documento novo vai no fim (a volta à lista única não parece mudança). */
const uniaoNaOrdem = (anterior: string[] | undefined, mapa: MapaPorParentesco) => {
  const u = uniao(mapa);
  return [...(anterior ?? []).filter((d) => u.includes(d)), ...u.filter((d) => !(anterior ?? []).includes(d))];
};

export interface IListaDeDocumentos {
  mandatoryDocuments?: string[];
  /** D41: quando existe, cada parentesco exige só a sua lista. `null` volta à lista única. */
  mandatoryDocumentsByKinship?: MapaPorParentesco | null;
}

interface IProps {
  lista: IListaDeDocumentos;
  allowedDependentTypes?: string[];
  onChange: (lista: IListaDeDocumentos) => void;
}

/**
 * Documentos obrigatórios de uma regra (D41). Sem mapa, a lista única de antes, que vale para
 * todos, e o botão que a separa por parentesco com a sugestão. Com mapa, uma linha por parentesco.
 * O mapa só entra no payload quando a corretora mexe (revisão do arquiteto, 28/10).
 */
export function DocumentosPorParentesco({ lista, allowedDependentTypes, onChange }: IProps) {
  const mapa = lista.mandatoryDocumentsByKinship;
  const options = [...DOCUMENTOS];

  if (!mapa) {
    const linhas = linhasDeParentesco(allowedDependentTypes);
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <MultiSelectWithSelectAll
          label="Documentos (todas as pessoas)"
          value={lista.mandatoryDocuments ?? []}
          options={options}
          onChange={(values) => onChange({ ...lista, mandatoryDocuments: values })}
        />
        <Button
          size="small"
          sx={{ alignSelf: "flex-start" }}
          onClick={() => {
            const novo = sugestao(lista.mandatoryDocuments, linhas);
            onChange({ ...lista, mandatoryDocumentsByKinship: novo, mandatoryDocuments: uniaoNaOrdem(lista.mandatoryDocuments, novo) });
          }}
        >
          Definir por parentesco
        </Button>
      </div>
    );
  }

  const linhas = linhasDeParentesco(allowedDependentTypes, mapa);
  const atualiza = (novo: MapaPorParentesco) => onChange({ ...lista, mandatoryDocumentsByKinship: novo, mandatoryDocuments: uniaoNaOrdem(lista.mandatoryDocuments, novo) });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <Subtitle style={{ width: "auto" }}>Documentos por parentesco: cada pessoa entrega só os da sua linha.</Subtitle>
      {linhas.map((p) => (
        <div key={p} style={{ display: "flex", gap: 16, alignItems: "center" }}>
          <span style={{ width: 260, fontSize: 14 }}>{ROTULO_PARENTESCO[p]}</span>
          <MultiSelectWithSelectAll
            label="Documentos"
            value={mapa[p] ?? []}
            options={options}
            onChange={(values) => atualiza({ ...mapa, [p]: values })}
          />
        </div>
      ))}
      <Button
        size="small"
        color="inherit"
        sx={{ alignSelf: "flex-start" }}
        onClick={() => onChange({ ...lista, mandatoryDocumentsByKinship: null, mandatoryDocuments: uniaoNaOrdem(lista.mandatoryDocuments, mapa) })}
      >
        Usar uma lista só para todos
      </Button>
    </div>
  );
}
